import { styled } from '@rybr/styled-modules'
import React from 'react'

import { FormattedColorTheme } from '@ntc/lib/utils/sanity-utils'

import { joinClassNames } from '@lib/common-utils'

const MainContainer = styled.div('PromoTag')

const BeforeAndAfterText = styled.p<{ colorTheme?: FormattedColorTheme }>(null, ({ colorTheme }) => ({
  color: colorTheme?.textColor,
  backgroundColor: colorTheme?.backgroundColor,
  borderTopColor: colorTheme?.textColor
}))

const ExponentText = styled.p<{ colorTheme?: FormattedColorTheme }>(null, ({ colorTheme }) => ({
  color: colorTheme?.accentColor,
  backgroundColor: colorTheme?.backgroundColor,
  borderTopColor: colorTheme?.accentColor
}))

const Text = styled.p<{ colorTheme?: FormattedColorTheme }>('PromoTagText', ({ colorTheme }) => ({
  color: colorTheme?.accentColor,
  backgroundColor: colorTheme?.backgroundColor,
  borderTopColor: colorTheme?.accentColor
}))

export const PromoTag: React.FC<{
  colorTheme?: FormattedColorTheme
  promoTag?: {
    textBefore?: string | null
    exponentLeft?: string | null
    text?: string | null
    exponentRight?: string | null
    textAfter?: string | null
  }
  textBeforeStyle?: string
  exponentLeftStyle?: string
  textStyle?: string
  exponentRightStyle?: string
  textAfterStyle?: string
}> = ({ colorTheme, promoTag, exponentLeftStyle, exponentRightStyle, textAfterStyle, textBeforeStyle, textStyle }) => {
  return (
    <MainContainer>
      <BeforeAndAfterText
        className={joinClassNames('PromoTagTextBefore', textBeforeStyle)}
        $colorTheme={colorTheme}
      >
        {promoTag?.textBefore}
      </BeforeAndAfterText>
      <ExponentText
        className={joinClassNames('PromoTagExponentLeft', exponentLeftStyle)}
        $colorTheme={colorTheme}
      >
        {promoTag?.exponentLeft}
      </ExponentText>
      <Text
        className={textStyle}
        $colorTheme={colorTheme}
      >
        {promoTag?.text}
      </Text>
      <ExponentText
        className={joinClassNames('PromoTagExponentRight', exponentRightStyle)}
        $colorTheme={colorTheme}
      >
        {promoTag?.exponentRight}
      </ExponentText>
      <BeforeAndAfterText
        className={joinClassNames('PromoTagTextAfter', textAfterStyle)}
        $colorTheme={colorTheme}
      >
        {promoTag?.textAfter}
      </BeforeAndAfterText>
    </MainContainer>
  )
}
